import api from 'service/api'

const dponetAPI = api.create('dponet')

const index = async () => {
  return await dponetAPI.get('/smtp_credentials')
}

const show = async () => {
  return await dponetAPI.get('/smtp_credentials/show')
}

const create = async (data) => {
  return await dponetAPI.post('/smtp_credentials', data)
}

const update = async ({ smtpCredentialId, ...data }) => {
  return await dponetAPI.put(`/smtp_credentials/${smtpCredentialId}`, data)
}

const testConnection = async () => {
  return await dponetAPI.patch('/smtp_credentials/test_connection')
}

const mailLog = async () => {
  return await dponetAPI.get('/smtp_credentials/mail_logs')
}

const smtp = {
  index,
  show,
  create,
  update,
  testConnection,
  mailLog,
}

export default smtp
